import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import userKeys from '../user/keys';
import keys from './keys';
import useMessage from '../../useMessage';

const useDeleteShow = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, hardDelete }) => `/shows/${showId}${hardDelete ? '?hard=1' : ''}`,
    method: 'DELETE',
    onSuccess: () => {
      queryClient.invalidateQueries(keys().shows);
      queryClient.invalidateQueries(userKeys.me);
    },
    onError: () => {
      message.danger({
        content: <FormattedMessage defaultMessage="There was an error while deleting your show." />,
      });
    },
  });

  return {
    deleteShow: mutation.mutate,
    isDeleteShowLoading: mutation.isLoading,
    isDeleteShowError: mutation.isError,
    isDeleteShowSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDeleteShow;
